import classNames from 'clsx';
import React from 'react';
import { useForm } from 'react-final-form';

import type { Props } from '@swf/components/Inputs/Input';
import Tel from '@swf/components/Inputs/Tel';
import Text from '@swf/components/Inputs/Text';
import useErrorHandling from '@swf/core/hooks/useErrorHandling';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { serverFieldErrMsgWarning } from '@swf/core/utils/validators';

import useDisableField from '../../hooks/useDisableField';

import { label, root } from './TextInput.scss';

interface InputProps extends Props {
  checkDisabled?: boolean;
}

const TextInput: React.FC<InputProps> = ({
  checkDisabled,
  id,
  validators,
  recordValidator,
  ...props
}) => {
  const { error } = useWizardContext();
  const { removeError } = useErrorHandling();
  const disableField = useDisableField();
  const form = useForm();
  const Component = props.type === 'tel' ? Tel : Text;

  return (
    <Component
      {...props}
      {...(!error && { recordValidator })}
      id={id}
      validators={[
        ...(validators || []),
        serverFieldErrMsgWarning(error, () => error && removeError(error), form)
      ]}
      className={classNames(props.className, root)}
      labelClassName={classNames(props.labelClassName, label)}
      showValidationTick={false}
      {...(checkDisabled && { disabled: disableField(id) })}
    />
  );
};

export default TextInput;
